import BaseService from "./BaseService";

class UserService {
  static async getUsers(token, params) {
    try {
        if (params) {
          return await BaseService.get("users", '', params);
        }
        return await BaseService.get("users", token);
    } catch (error) {
      console.error("There was an error fetching the users!", error);
      throw error;
    }
  }
  static async postUser(userData, token) {
    try {
      return await BaseService.post("users", userData, token);
    } catch (error) {
      console.error("There was an error posting the user!", error);
      throw error;
    }
  }
  static async registerUser(userData) {
    try {
      return await BaseService.post("users/register", userData, null);
    } catch (error) {
      console.error("There was an error registering the user!", error);
      throw error;
    }
  }
  static async resetPassword(params) {
    try {
      return await BaseService.post("password/reset-password", {}, '', params);
    } catch (error) {
      console.error("There was an error posting the user!", error);
      throw error;
    }
  }
  static async editUser(id, userData, resetPassword) {
    try {
      if(resetPassword){
        return await BaseService.put("password/reset-password", id, userData, null);
      }
      return await BaseService.put("users", id, userData);
    } catch (error) {
      console.error("There was an error editing the user!", error);
      throw error;
    }
  }

  static async updateProfile(profileData) {
    try {
      return await BaseService.put("users", 'profile', profileData);
    } catch (error) {
      console.error("There was an error updating the profile!", error);
      throw error;
    }
  }

  static async getPrivacyConsentStatus() {
    try {
      return await BaseService.get("users/profile/privacy-consent", null);
    } catch (error) {
      console.error("There was an error fetching privacy consent status!", error);
      throw error;
    }
  }

  static async acceptPrivacyConsent(version = "v1") {
    try {
      return await BaseService.put("users/profile", "privacy-consent", { Version: version });
    } catch (error) {
      console.error("There was an error accepting privacy consent!", error);
      throw error;
    }
  }

  static async deleteUser(Id, token) {
    try {
      return await BaseService.delete("users", Id, token);
    } catch (error) {
      console.error("There was an error deleting the user!", error);
      throw error;
    }
  }
}

export default UserService;